// Libs
import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

// Components
import Input from '../../../../../Field/Input';
import MultipleSelect from '../../../../../Field/MultipleSelect';

// Validation Schema
import { scheduleDetailsSchema } from '../../../../../../validationSchema';
import Disclaimer from '../../../OrderProcessingInfo/Disclaimer';

// Styles
import { useStyles } from './WeeklyStyles';

const Weekly = ({
  weekly,
  onChangeMonthCount = () => {},
  onChangeMultipleSelect = () => {},
  setMonthError = () => {},
  disclaimer,
  openOrderProcessingWindow,
}) => {
  const { classes } = useStyles();

  const {
    control,
    trigger,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(scheduleDetailsSchema),
    defaultValues: {
      monthNumberForWeekly: weekly?.monthNumber,
    },
  });

  useEffect(() => {
    trigger();
  }, [trigger]);

  useEffect(() => {
    if (errors.monthNumberForWeekly) {
      setMonthError(errors.monthNumberForWeekly?.message);
    } else {
      setMonthError('');
    }
  }, [setMonthError, errors.monthNumberForWeekly]);

  return (
    // <div style={{ position: 'relative', display: 'flex', flexWrap: 'wrap' }}>
    <div className={classes.container}>
      Every
      <MultipleSelect
        labelColor="#C6CAC6"
        classic
        name="weekly"
        onChangeFilter={onChangeMultipleSelect}
        width={132}
        className={classes.multipleSelect}
        label="Select"
        required
        items={weekly?.days}
      />
      Of Every
      <Controller
        name="monthNumberForWeekly"
        control={control}
        render={({ field }) => {
          return (
            <Input
              {...field}
              maxLength={2}
              name="monthNumberForWeekly"
              onChange={onChangeMonthCount(field.onChange)}
              className={classes.input}
              value={weekly?.monthNumber}
              error={errors?.monthNumberForWeekly?.message}
            />
          );
        }}
      />
      <span className={classes.fieldLabel}>Week(s)</span>
      {disclaimer && (
        <Disclaimer
          onClick={openOrderProcessingWindow}
          className={classes.disclaimer}
          disclaimer={disclaimer}
        />
      )}
    </div>
  );
};

export default Weekly;
